import { FileItem } from './types';

/** Extensions that can carry a flight-analysis verdict. */
const ANALYSABLE = /\.(csv|bin)$/i;

/**
 * Which entries the grid should ask for analysis verdicts, as `object_id`s.
 *
 * Keyed on identity, never on a path (#1326). This used to hand the grid's
 * display keys to a query against `flight_analysis_results.s3_key`, which holds
 * a *storage* key: the display path has the org prefix stripped, so the two
 * sides could not match and no file ever showed a badge. #1280's uuid blob keys
 * make any path↔key resemblance permanently impossible, so identity is the only
 * join that can hold.
 *
 * Three exclusions, each of which is a "no badge" answer rather than a gap:
 *
 * 1. **Folders** — a verdict is a property of one analysed file.
 * 2. **Anything that is not csv/bin** — nothing else is analysed.
 * 3. **Entries with no `object_id`** — the legacy flights arm has no
 *    `fleet.file_objects` row, so there is nothing for a verdict to be keyed
 *    to. Same shape as `shareTargets`' drop rule, and for the same reason.
 *
 * Pure and separate from the component so it can be unit-tested: this app ships
 * no jsdom/RTL, so a hook rendered inside a component is unreachable, and `tsc`
 * cannot tell a right filter from a wrong one.
 */
export function analysisTargetIds(files: readonly FileItem[]): string[] {
  return files
    .filter((f) => !f.isFolder && ANALYSABLE.test(f.key))
    .map((f) => f.object_id)
    .filter((id): id is string => !!id);
}
